
export default {
  name: 'SymbolOverrides',
  values: {
    EUR: '€',
    GBP: '£',
    USD: '$',
    COP: '$',
  },
  meta: {
    extendable: true,
  },
}
